import React, { useState, useEffect, useContext } from 'react'
import AdminContext from '../../StateContext/Application';
import { apiurl } from '../../../../path';
import { Link } from 'react-router-dom';
import { Back32, Cancel32, ProposalCreation32, submit } from '../../../../public/LoginImages/importimages';

import { useLanguage } from '../../../../lang/langcontext/LanguageContext';

const DemandRequestInwardList = () => {
    const { language, toggleLanguage, t } = useLanguage();
    const context = useContext(AdminContext)
    const { GetDemandRequestInwardsList, DemandRequestApprovalOperation } = context;

    const [technicalInwards, setTechnicalInwards] = useState([])
    const [loading, setLoading] = useState(false);
    const [selectedBills, setSelectedBills] = useState([]);
    const [filteredBills, setFilteredBills] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const billsPerPage = 10;
    const [searchTerm, setSearchTerm] = useState('');

    const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
    const indexOfLastBill = currentPage * billsPerPage;
    const indexOfFirstBill = indexOfLastBill - billsPerPage;
//     const sortedBills = Array.isArray(filteredBills)? filteredBills.slice() // ✅ prevent state mutation
// .sort((a, b) => new Date(b.created_At) - new Date(a.created_At))
//         : [];
 const sortedBills = filteredBills;
    const currentBills = sortedBills?.slice(indexOfFirstBill, indexOfLastBill);
    // const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);
    const [rejectPanelhide, setRejectpanelhide] = useState(1);
    const [remark, setRemark] = useState("");

    const getTechnicalInwardsList = async () => {
        let data = await GetDemandRequestInwardsList('All', 'null')
        console.log("data------------", data);

        setTechnicalInwards(data)
        setFilteredBills(data);
    }

    useEffect(() => {
        getTechnicalInwardsList()
    }, []);

    let inwardList = []
    if (technicalInwards.length > 0) {
        inwardList = technicalInwards
    }
    useEffect(() => {
        const lowerSearchTerm = searchTerm.toLowerCase();
        const filtered = technicalInwards
            .filter(bill => bill.Status !== "Rejected")
            .filter(bill =>
                Object.values(bill).some((val) =>
                    (val || '').toString().toLowerCase().includes(lowerSearchTerm)
                )
            );
        setFilteredBills(filtered);
        setCurrentPage(1);
    }, [searchTerm, technicalInwards]);



    const handleCheckboxChange = (id) => {
        setSelectedBills((prevSelected) =>
            prevSelected.includes(id)
                ? prevSelected.filter((billId) => billId !== id)
                : [...prevSelected, id]
        );
    };

    console.log("Slected id form table :: ", selectedBills);
    console.log("Filtered data id form table :: ", filteredBills);

    const handleSelectAll = (event) => {
        if (event.target.checked) {
            setSelectedBills(currentBills.map((bill) => bill.DRID));
        } else {
            setSelectedBills([]);
        }
    };


    const approveorrejectSelected = async (condition) => {
        if (selectedBills.length === 0) {
            alert('No Demand Request selected for approval!');
            return;
        }
           if(condition=="Rejected"||condition=="SendBack"){
           const cleanRemark = remark.trim().replace(/\s+/g, " ");

    // ❌ If remark is empty after trimming
    if (!cleanRemark) {
        alert("Remark is required and cannot be empty!");
        return;
    }}
        console.log(selectedBills);
        setLoading(true); // Start loader
        let shouldStart = window.confirm("Are you sure ??");
        if (shouldStart) {
            try {
                let response = await DemandRequestApprovalOperation(selectedBills, condition, remark); // Call backend function
                if (response.message) {
                    alert(response.message);
                    setRemark('');
                    setRejectpanelhide(0);
                    getTechnicalInwardsList(); 
                    setSelectedBills([]);  // Refresh the list after approval
                }
                if (response.error) {
                    alert(response.error);
                    setRemark('');
                    setRejectpanelhide(0);
                    getTechnicalInwardsList();
                    setLoading(false)
                    setSelectedBills([]);
                }
            } catch (error) {
                console.error('Error approving Proposal:', error);
                alert('An error occurred while approving bills.');
                setRemark('');
                setLoading(false)
                setRejectpanelhide(0);
            }
            finally {
                setLoading(false);
            }
        }
        else {
            alert(`Gr ${condition} Operation Cancelled !!!`);
            setRemark('');
            setRejectpanelhide(0);
            window.location.reload();
            getTechnicalInwardsList();
        }
        setLoading(false); // Stop loader
    };
    const headerStyle = {
        padding: "12px 16px",
        whiteSpace: "nowrap",
        borderRight: "1px solid #e0e0e0",

    };

    return (

        <>
            <div className='col-12 px-4' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>

                <div className='col-12 px-3 m-auto'>
                    <div className='col-12 px-4 mb-4 mt-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        {/* <h4 style={{ margin: "10px 0px" }}></h4> */}
                        <h5 className='my-auto fw-bold'>
                            <img src="/GR-Approval64.png" alt="DemandInward" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
                            <span className='my-auto'>{t("Demand Request Inward List")}</span>
                        </h5>
                        <div style={{ position: "relative", width: "250px", marginRight: "10px" }}>
                            <img
                                src="/Search32.png"
                                alt="Search Icon"
                                style={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "10px",
                                    transform: "translateY(-50%)",
                                    width: "16px",
                                    height: "16px",
                                    opacity: 0.6
                                }}
                            />
                            <input
                                type="text"
                                placeholder={t("Search Here")}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                value={searchTerm}
                                style={{
                                    width: "100%",
                                    padding: "8px 12px 8px 32px", // left padding makes space for icon
                                    border: "1px solid #ccc",
                                    borderRadius: "8px",
                                    backgroundColor: "#f1f6fc",
                                    fontSize: "14px",
                                    color: "#333",
                                    boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                                    outline: "none"
                                }}
                            />
                        </div>
                    </div>
                </div>

                {loading && (
                    <div
                        style={{
                            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(255, 255, 255, 0.7)', backdropFilter: 'blur(4px)', zIndex: 9999,
                            display: 'flex', justifyContent: 'center', alignItems: 'center'
                        }}>
                        <div style={{ border: '6px solid #f3f3f3', borderTop: '6px solid #007bff', borderRadius: '50%', width: '60px', height: '60px', animation: 'spin 1s linear infinite' }} />
                        <style>
                            {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
                        </style>
                    </div>
                )}


                <div className='m-auto' style={{ backgroundColor: "white", padding: "30px 30px", boxShadow: "0px 0px 5px 1px #c7c9cc", borderRadius: "20px" }}>
                    <div className='col-12 tableDesign' style={{ background: '#2C78DB', overflowX: "scroll" }}>
                        <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                                <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
                                    <th style={{ width: "5%" }}><input
                                        type="checkbox"
                                        onChange={handleSelectAll}
                                        checked={selectedBills.length === currentBills.length}
                                        className='my-auto'
                                        style={{ height: '1rem', width: '1rem' }}
                                    />
                                    </th>
                                    {/* <th style={{ width: "3%" }}>View</th> */}
                                    <th style={{ padding: "7px 10px", width: "6%" }}>{t("Sr.No")}</th>
                                    <th style={{ padding: "7px 10px", width: "10%" }}>{t("Demand Request ID")}</th>
                                    <th style={{ padding: "7px 10px", width: "20%" }}>{t("Head Code")}</th>
                                    <th style={{ padding: "7px 10px", width: "20%" }}>{t("Work Order Name")}</th>
                                    <th style={{ padding: "7px 10px", width: "20%" }}>{t("Job ID")}</th>
                                    <th style={{ padding: "7px 10px", width: "20%" }}>{t("Approved Work Name")}</th>
                                    <th style={{ padding: "7px 10px", width: "20%" }}>{t("MHUID Number")}</th>
                                    <th style={{ padding: "7px 10px", width: "20%" }}>{t("Physical Progress In %")}</th>
                                    <th style={{ padding: "7px 10px", width: "20%" }}>{t("District")}</th>
                                    <th style={{ padding: "7px 10px", width: "26%" }}>{t("Year")}</th>
                                    <th style={{ padding: "7px 10px", width: "20%" }}>{t("Demand Request Amount")}</th>
                                    <th style={{ padding: "7px 10px", width: "20%" }}>{t("Demand Request Date")}</th>
                                </tr>
                            </thead>
                            {
                                currentBills?.length === 0 ? (
                                    <tr>
                                        <td colSpan="13" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
                                            {t("No data available")}
                                        </td>
                                    </tr>
                                ) : (

                                    currentBills?.map((technicalInwards, index) => {
                                        const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                        return (
                                            <tbody>
                                                <tr className='px-3' key={index} style={{ backgroundColor: bgColor, fontSize: "12px", fontWeight: "400" }}>
                                                    <td style={{ height: '2.5rem' }}>
                                                        <input
                                                            type="checkbox"
                                                            className='my-auto'
                                                            style={{ height: '1rem', width: '1rem' }}
                                                            checked={selectedBills.includes(technicalInwards.DRID)}
                                                            onChange={() => handleCheckboxChange(technicalInwards.DRID)}
                                                        />
                                                    </td>
                                                    <td style={{ textAlign: "center" }}>{indexOfFirstBill + index + 1}</td>
                                                    <td className='py-2'>{technicalInwards.DRID}</td>
                                                    <td className='py-2'>{technicalInwards.HeadCode}</td>
                                                    <td className='py-2'>{technicalInwards.WorkName}</td>
                                                     <td className='py-2'>{technicalInwards.JOB_ID}</td>
                                                    <td className='py-2'>{technicalInwards.ProposalWorkName}</td>
                                                    <td className='py-2'>{technicalInwards.MHUID}</td>
                                                    <td className='py-2'>{technicalInwards.physicalValue}</td>
                                                    <td className='py-2'>{technicalInwards.District}</td>
                                                    <td className='py-2'>{technicalInwards.Year}</td>
                                                    <td className='py-2'>{technicalInwards.DRAmount}</td>
                                                    <td className='py-2'>{new Date(technicalInwards.created_At).toLocaleString()}</td>
                                                </tr>
                                            </tbody>
                                        )
                                    })
                                )
                            }
                        </table>

                    </div>

                    <div className='col-12 mt-3'>

                        <div
                            className="my-2 d-flex justify-content-between align-items-center"
                            style={{ flexWrap: "wrap" }}
                        >

                            <p className="text-gray-600" style={{ fontSize: "14px", margin: 0 }}>{t("Showing")} {filteredBills.length > 0 ? indexOfFirstBill + 1 : 0}  {t("to")} {Math.min(indexOfLastBill, filteredBills?.length)} {t("of")} {filteredBills?.length} {t("entries")}</p>
                            <div className="col-6 text-end">
                                {/* First Page Button */}
                                <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
                                    style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', width: '2rem' }}>
                                    &laquo;
                                </button>
                                {/* Previous Button */}
                                <button
                                    onClick={() => setCurrentPage(currentPage - 1)}
                                    disabled={currentPage === 1}
                                    style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
                                    &lt;
                                </button>

                                <button
                                    style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '20px', width: '2.4rem', border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
                                </button>
                                {/* Next Button */}
                                <button
                                    onClick={() => setCurrentPage(currentPage + 1)}
                                    disabled={currentPage === totalPages}
                                    style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
                                    &gt;
                                </button>
                                {/* Last Page Button */}
                                <button
                                    onClick={() => setCurrentPage(totalPages)}
                                    disabled={currentPage === totalPages}
                                    style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
                                    &raquo;
                                </button>
                            </div>
                            <div className='col-6 text-start' style={{ display: 'flex', justifyContent: 'left' }}>
                                <button
                                    onClick={() => approveorrejectSelected("Approved")} disabled={selectedBills.length <= 0 ? true : loading}
                                    className='ms-0'
                                    // onClick={(e) => { SetGenerateToken(false) }}
                                    style={{
                                        display: 'flex', alignItems: 'center', gap: '0.3rem', margin: '12px', padding: '8px 10px', fontWeight: "600",
                                        backgroundColor: selectedBills.length <= 0 ? (
                                            'rgba(141, 141, 141, 0.97)'
                                        ) : ('#39B54A'),
                                        color: 'white', borderRadius: '8px',
                                        cursor: selectedBills.length <= 0 ? 'not-allowed' : loading ? 'not-allowed' : 'pointer'
                                    }}
                                ><img src='/Approve-Selected32.png' style={{ width: '1rem', height: '1rem', filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : t("Approve Selected")}
                                </button>

                                <button
                                    onClick={() => setRejectpanelhide(2)} disabled={selectedBills.length <= 0 ? true : loading}
                                    style={{
                                        display: 'flex', alignItems: 'center', gap: '0.3rem', margin: '12px', padding: '8px 10px', fontWeight: "600",
                                        background: selectedBills.length <= 0 ? (
                                            'rgba(141, 141, 141, 0.97)'
                                        ) : ('#C1272D'),
                                        color: 'white', borderRadius: '8px',
                                        cursor: selectedBills.length <= 0 ? 'not-allowed' : loading ? 'not-allowed' : 'pointer'
                                    }}
                                ><img src='/Reject-Selected32.png' style={{ width: '1rem', height: '1rem', filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : t("Reject Selected")}
                                </button>

                                {/* <button
                                        onClick={() => setRejectpanelhide(3)} disabled={selectedBills.length <= 0 ? true : loading}
                                        style={{
                                            display: 'flex', alignItems: 'center', gap: '3px', margin: '12px', padding: '8px 10px', fontWeight: "600",
                                            background: selectedBills.length <= 0 ? (
                                                'rgba(141, 141, 141, 0.97)'
                                            ) : ('linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)'),
                                            color: 'white', borderRadius: '8px',
                                            cursor: selectedBills.length <= 0 ? 'not-allowed' : loading ? 'not-allowed' : 'pointer'
                                        }}
                                    ><img src='/Send-Back-Selected32.png' style={{ width: '1rem', height: "1rem", filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : t("Send Back Selected")}
                                    </button> */}
                            </div>

                        </div>
                    </div>

                </div>
            </div>



            {
                rejectPanelhide === 2 &&

                <div className='col-12 RejectPanelContainer'>
                    <div className="Rejectpanel">
                        <form action="">

                            <div className="col-12 elements">
                                <div className="row">
                                    <div className="col-3">
                                        <label className='fw-bold'>{t("Remark")} <span className='text-danger'>*</span></label>
                                    </div>
                                    <div className="col-8">
                                        <textarea name="" id="" placeholder={t("Enter Remark")} value={remark} onChange={(e) => setRemark(e.target.value.replace(/^\s+/, ""))}>
                                        </textarea>
                                    </div>
                                </div>
                            </div>

                        </form>
                        <div className="col-12 ms-auto my-4">
                            <div className="row">
                                {/* <div className="col-3"></div> */}
                                <div className="col-9 m-auto">
                                    <div className="col-12" style={{ display: 'flex', gap: '10px', justifyContent: "center" }}>
                                        <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', width: '5rem', height: '2rem', fontSize: '18px' }} onClick={() => approveorrejectSelected("Rejected")}><img src={submit} style={{ width: '15px' }} /> Reject</button>
                                        <button type="button" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', backgroundColor: '#f1594c', width: '6rem', height: '2rem', fontSize: '16px' }} onClick={() => window.location.reload()}> <img src={Cancel32} style={{ width: '17px' }} />Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            }

            {
                rejectPanelhide === 3 &&

                <div className='col-12 RejectPanelContainer'>
                    <div className="Rejectpanel">
                        <form action="">

                            <div className="col-12 elements">
                                <div className="row">
                                    <div className="col-3">
                                        <label className='fw-bold'>{t("Remark")} <span className='text-danger'>*</span></label>
                                    </div>
                                    <div className="col-8">
                                        <textarea name="" id="" placeholder={t("Enter Remark")} value={remark} onChange={(e) => setRemark(e.target.value.replace(/^\s+/, ""))}>
                                        </textarea>
                                    </div>
                                </div>
                            </div>

                        </form>
                        <div className="col-12 ms-auto my-4">
                            <div className="row">
                                {/* <div className="col-3"></div> */}
                                <div className="col-9 m-auto">
                                    <div className="col-12" style={{ display: 'flex', gap: '10px', justifyContent: "center" }}>
                                        <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', width: '8rem', height: '2rem', fontSize: '18px' }} onClick={() => approveorrejectSelected("SendBack")}><img src={submit} style={{ width: '15px' }} /> {t("Send Back")}</button>
                                        <button type="button" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', backgroundColor: '#f1594c', width: '6rem', height: '2rem', fontSize: '16px' }} onClick={() => window.location.reload()}> <img src={Cancel32} style={{ width: '17px' }} />{t("Cancel")}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            }


        </>

    )
}

export default DemandRequestInwardList;


// import AdminContext from '../../StateContext/Application';
// import { apiurl } from '../../../../path';
// import { Link } from 'react-router-dom';
// import { Back32, Cancel32, ProposalCreation32, submit } from '../../../../public/LoginImages/importimages';


// const DemandRequestInwardList = () => {
//     const context = useContext(AdminContext)
//     const { GetDemandRequestInwardsList, DemandRequestApprovalOperation } = context;

//     const [technicalInwards, setTechnicalInwards] = useState([])
//     const [loading, setLoading] = useState(false);
//     const [selectedBills, setSelectedBills] = useState([]);
//     const [filteredBills, setFilteredBills] = useState([]);
//     const [currentPage, setCurrentPage] = useState(1);
//     const billsPerPage = 10;
//     const [searchTerm, setSearchTerm] = useState('');

//     const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
//     const indexOfLastBill = currentPage * billsPerPage;
//     const indexOfFirstBill = indexOfLastBill - billsPerPage;
//     const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);
//     const [rejectPanelhide, setRejectpanelhide] = useState(1);
//     const [remark, setRemark] = useState("");

//     const getTechnicalInwardsList = async () => {
//         let data = await GetDemandRequestInwardsList('All', 'null')
//         console.log("data------------", data);

//         setTechnicalInwards(data)
//         setFilteredBills(data);
//     }

//     useEffect(() => {
//         getTechnicalInwardsList()
//     }, []);

//     let inwardList = []
//     if (technicalInwards.length > 0) {
//         inwardList = technicalInwards
//     }
//     useEffect(() => {
//         const lowerSearchTerm = searchTerm.toLowerCase();
//         const filtered = technicalInwards.filter(bill =>
//             Object.values(bill).some((val) =>
//                 (val || '').toString().toLowerCase().includes(lowerSearchTerm)
//             )
//         );
//         setFilteredBills(filtered);
//         setCurrentPage(1);
//     }, [searchTerm, technicalInwards]);



//     const handleCheckboxChange = (id) => {
//         setSelectedBills((prevSelected) =>
//             prevSelected.includes(id)
//                 ? prevSelected.filter((billId) => billId !== id)
//                 : [...prevSelected, id]
//         );
//     };

//     console.log("Slected id form table :: ", selectedBills);
//     console.log("Filtered data id form table :: ", filteredBills);

//     const handleSelectAll = (event) => {
//         if (event.target.checked) {
//             setSelectedBills(currentBills.map((bill) => bill.DRID));
//         } else {
//             setSelectedBills([]);
//         }
//     };


//     const approveorrejectSelected = async (condition) => {
//         if (selectedBills.length === 0) {
//             alert('No Demand Request selected for approval!');
//             return;
//         }
//         console.log(selectedBills);
//         setLoading(true); // Start loader
//         let shouldStart = window.confirm("Are you sure ??");
//         if (shouldStart) {
//             try {
//                 let response = await DemandRequestApprovalOperation(selectedBills, condition, remark); // Call backend function
//                 if (response.message) {
//                     alert(response.message);
//                     setRemark('');
//                     setRejectpanelhide(0);
//                     getTechnicalInwardsList(); // Refresh the list after approval
//                 }
//                 if (response.error) {
//                     alert(response.error);
//                     setRemark('');
//                     setRejectpanelhide(0);
//                     getTechnicalInwardsList();
//                     setLoading(false)
//                 }
//             } catch (error) {
//                 console.error('Error approving Proposal:', error);
//                 alert('An error occurred while approving bills.');
//                 setRemark('');
//                 setLoading(false)
//                 setRejectpanelhide(0);
//             }
//             finally {
//                 setLoading(false);
//             }
//         }
//         else {
//             alert(`Gr ${condition} Operation Cancelled !!!`);
//             setRemark('');
//             setRejectpanelhide(0);
//             window.location.reload();
//             getTechnicalInwardsList();
//         }
//         setLoading(false); // Stop loader
//     };


//     return (

//         <>
//             <div className='col-12 px-4' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>

//                 <div className='col-12 px-3 m-auto'>
//                     <div className='col-12 px-4 mb-4 mt-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//                         {/* <h4 style={{ margin: "10px 0px" }}></h4> */}
//                         <h5 className='my-auto fw-bold'>
//                             <img src="/GR-Approval64.png" alt="DemandInward" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
//                             <span className='my-auto'>Demand Request Inward List</span>
//                         </h5>
//                         <div style={{ position: "relative", width: "250px", marginRight: "10px" }}>
//                             <img
//                                 src="/Search32.png"
//                                 alt="Search Icon"
//                                 style={{
//                                     position: "absolute",
//                                     top: "50%",
//                                     left: "10px",
//                                     transform: "translateY(-50%)",
//                                     width: "16px",
//                                     height: "16px",
//                                     opacity: 0.6
//                                 }}
//                             />
//                             <input
//                                 type="text"
//                                 placeholder="Search Here"
//                                 onChange={(e) => setSearchTerm(e.target.value)}
//                                 value={searchTerm}
//                                 style={{
//                                     width: "100%",
//                                     padding: "8px 12px 8px 32px", // left padding makes space for icon
//                                     border: "1px solid #ccc",
//                                     borderRadius: "8px",
//                                     backgroundColor: "#f1f6fc",
//                                     fontSize: "14px",
//                                     color: "#333",
//                                     boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
//                                     outline: "none"
//                                 }}
//                             />
//                         </div>
//                     </div>
//                 </div>

//                 {loading && (
//                     <div
//                         style={{
//                             position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(255, 255, 255, 0.7)', backdropFilter: 'blur(4px)', zIndex: 9999,
//                             display: 'flex', justifyContent: 'center', alignItems: 'center'
//                         }}>
//                         <div style={{ border: '6px solid #f3f3f3', borderTop: '6px solid #007bff', borderRadius: '50%', width: '60px', height: '60px', animation: 'spin 1s linear infinite' }} />
//                         <style>
//                             {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
//                         </style>
//                     </div>
//                 )}


//                 <div className='m-auto' style={{ width: "98%", backgroundColor: "white", padding: "30px 30px", boxShadow: "0px 0px 5px 1px #c7c9cc", borderRadius: "20px" }}>
//                     <div className='col-12 tableDesign' style={{ background: '#2C78DB' }}>
//                         <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
//                             <thead>
//                                 <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
//                                     <th style={{ width: "5%" }}><input
//                                         type="checkbox"
//                                         onChange={handleSelectAll}
//                                         checked={selectedBills.length === currentBills.length}
//                                        className='my-auto'
//                                                 style={{ height: '1rem', width: '1rem' }}
//                                     />
//                                     </th>
//                                     {/* <th style={{ width: "3%" }}>View</th> */}
//                                     <th style={{ width: "10%" }}>Demand Request ID</th>
//                                     <th style={{ width: "10%" }}>Head Code</th>
//                                     <th style={{ width: "20%" }}>Work Name</th>
//                                     <th style={{ width: "20%" }}>District</th>
//                                     <th style={{ width: "10%" }}>Year</th>
//                                     <th style={{ width: "20%" }}>Demand Request Amount</th>
//                                     <th style={{ width: "10%" }}>Demand Request Date </th>

//                                 </tr>
//                             </thead>
//                             {
//                                 currentBills?.map((technicalInwards, index) => {
//                                     const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                                     return (
//                                         <tbody>
//                                             <tr className='px-3' key={index} style={{ borderBottom: '1px solid #3b409e', backgroundColor: bgColor, }}>
//                                                 <td style={{ height: '2.5rem' }}>
//                                                     <input
//                                                         type="checkbox"
//                                                        className='my-auto'
//                                                                     style={{ height: '1rem', width: '1rem' }}
//                                                         checked={selectedBills.includes(technicalInwards.DRID)}
//                                                         onChange={() => handleCheckboxChange(technicalInwards.DRID)}
//                                                     />
//                                                 </td>
//                                                 <td className='py-2'>{technicalInwards.DRID}</td>
//                                                 <td className='py-2'>{technicalInwards.HeadName}</td>
//                                                 <td className='py-2'>{technicalInwards.WorkName}</td>
//                                                 <td className='py-2'>{technicalInwards.District}</td>
//                                                 <td className='py-2'>{technicalInwards.Year}</td>
//                                                 <td className='py-2'>{technicalInwards.DRAmount} CR</td>
//                                                 <td className='py-2'>{new Date(technicalInwards.created_At).toLocaleString()}</td>
//                                             </tr>
//                                         </tbody>
//                                     )
//                                 })
//                             }
//                         </table>

//                     </div>

//                     <div className='col-12 mt-3'>

//                         <div
//                             className="my-2 d-flex justify-content-between align-items-center"
//                             style={{ flexWrap: "wrap" }}
//                         >

//                             <p className="text-gray-600" style={{ fontSize: "14px", margin: 0 }}>Showing {filteredBills.length > 0 ? indexOfFirstBill + 1 : 0}  to {Math.min(indexOfLastBill, filteredBills?.length)} of {filteredBills?.length} entries</p>
//                             <div className="col-6 text-end">
//                                 {/* First Page Button */}
//                                 <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
//                                     style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', width: '2rem' }}>
//                                     &laquo;
//                                 </button>
//                                 {/* Previous Button */}
//                                 <button
//                                     onClick={() => setCurrentPage(currentPage - 1)}
//                                     disabled={currentPage === 1}
//                                     style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
//                                     &lt;
//                                 </button>

//                                 <button
//                                     style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '20px', width: '2.4rem', border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
//                                 </button>
//                                 {/* Next Button */}
//                                 <button
//                                     onClick={() => setCurrentPage(currentPage + 1)}
//                                     disabled={currentPage === totalPages}
//                                     style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
//                                     &gt;
//                                 </button>
//                                 {/* Last Page Button */}
//                                 <button
//                                     onClick={() => setCurrentPage(totalPages)}
//                                     disabled={currentPage === totalPages}
//                                     style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
//                                     &raquo;
//                                 </button>
//                             </div>
//                             <div style={{ display: 'flex', justifyContent: 'space-evenly', margin: '10px 0' }}>
//                                 <button
//                                     onClick={() => approveorrejectSelected("Approved")} disabled={selectedBills.length <= 0 ? true : loading}
//                                     className='ms-0'
//                                     // onClick={(e) => { SetGenerateToken(false) }}
//                                     style={{
//                                         display: 'flex', alignItems: 'center', gap: '0.3rem', margin: '12px', padding: '8px 10px', fontWeight: "600",
//                                         backgroundColor: selectedBills.length <= 0 ? (
//                                             'rgba(141, 141, 141, 0.97)'
//                                         ) : ('#39B54A'),
//                                         color: 'white', borderRadius: '8px',
//                                         cursor: selectedBills.length <= 0 ? 'not-allowed' : loading ? 'not-allowed' : 'pointer'
//                                     }}
//                                 ><img src='/Approve-Selected32.png' style={{ width: '1rem', height: '1rem', filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : 'Approve Selected'}
//                                 </button>

//                                 <button
//                                     onClick={() => setRejectpanelhide(2)} disabled={selectedBills.length <= 0 ? true : loading}
//                                     style={{
//                                         display: 'flex', alignItems: 'center', gap: '0.3rem', margin: '12px', padding: '8px 10px', fontWeight: "600",
//                                         background: selectedBills.length <= 0 ? (
//                                             'rgba(141, 141, 141, 0.97)'
//                                         ) : ('#C1272D'),
//                                         color: 'white', borderRadius: '8px',
//                                         cursor: selectedBills.length <= 0 ? 'not-allowed' : loading ? 'not-allowed' : 'pointer'
//                                     }}
//                                 ><img src='/Reject-Selected32.png' style={{ width: '1rem', height: '1rem', filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : 'Reject Selected'}
//                                 </button>

//                                 <button
//                                     onClick={() => setRejectpanelhide(3)} disabled={selectedBills.length <= 0 ? true : loading}
//                                     style={{
//                                         display: 'flex', alignItems: 'center', gap: '3px', margin: '12px', padding: '8px 10px', fontWeight: "600",
//                                         background: selectedBills.length <= 0 ? (
//                                             'rgba(141, 141, 141, 0.97)'
//                                         ) : ('linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)'),
//                                         color: 'white', borderRadius: '8px',
//                                         cursor: selectedBills.length <= 0 ? 'not-allowed' : loading ? 'not-allowed' : 'pointer'
//                                     }}
//                                 ><img src='/Send-Back-Selected32.png' style={{ width: '1rem', height: "1rem", filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : 'Send Back Selected'}
//                                 </button>
//                             </div>

//                         </div>
//                     </div>

//                 </div>
//             </div>



//             {
//                 rejectPanelhide === 2 &&

//                 <div className='col-12 RejectPanelContainer'>
//                     <div className="Rejectpanel">
//                         <form action="">

//                             <div className="col-12 elements">
//                                 <div className="row">
//                                     <div className="col-3">
//                                         <label className='fw-bold'>Remark <span className='text-danger'>*</span></label>
//                                     </div>
//                                     <div className="col-8">
//                                         <textarea name="" id="" placeholder='Enter Remark' onChange={(e) => setRemark(e.target.value)}>
//                                         </textarea>
//                                     </div>
//                                 </div>
//                             </div>

//                         </form>
//                         <div className="col-12 ms-auto my-4">
//                             <div className="row">
//                                 {/* <div className="col-3"></div> */}
//                                 <div className="col-9 m-auto">
//                                     <div className="col-12" style={{ display: 'flex', gap: '10px', justifyContent: "center" }}>
//                                         <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', width: '5rem', height: '2rem', fontSize: '18px' }} onClick={() => approveorrejectSelected("Rejected")}><img src={submit} style={{ width: '15px' }} /> Reject</button>
//                                         <button type="button" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', backgroundColor: '#f1594c', width: '6rem', height: '2rem', fontSize: '16px' }} onClick={() => window.location.reload()}> <img src={Cancel32} style={{ width: '17px' }} />Cancel</button>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                 </div>

//             }

//             {
//                 rejectPanelhide === 3 &&

//                 <div className='col-12 RejectPanelContainer'>
//                     <div className="Rejectpanel">
//                         <form action="">

//                             <div className="col-12 elements">
//                                 <div className="row">
//                                     <div className="col-3">
//                                         <label className='fw-bold'>Remark <span className='text-danger'>*</span></label>
//                                     </div>
//                                     <div className="col-8">
//                                         <textarea name="" id="" placeholder='Enter Remark' onChange={(e) => setRemark(e.target.value)}>
//                                         </textarea>
//                                     </div>
//                                 </div>
//                             </div>

//                         </form>
//                         <div className="col-12 ms-auto my-4">
//                             <div className="row">
//                                 {/* <div className="col-3"></div> */}
//                                 <div className="col-9 m-auto">
//                                     <div className="col-12" style={{ display: 'flex', gap: '10px', justifyContent: "center" }}>
//                                         <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', width: '8rem', height: '2rem', fontSize: '18px' }} onClick={() => approveorrejectSelected("SendBack")}><img src={submit} style={{ width: '15px' }} /> Send Back</button>
//                                         <button type="button" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', backgroundColor: '#f1594c', width: '6rem', height: '2rem', fontSize: '16px' }} onClick={() => window.location.reload()}> <img src={Cancel32} style={{ width: '17px' }} />Cancel</button>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                 </div>

//             }


//         </>

//     )
// }

// export default DemandRequestInwardList;